import { render, staticRenderFns } from "./LabelDetails.vue?vue&type=template&id=2a11a1bf&scoped=true"
import script from "./LabelDetails.vue?vue&type=script&lang=js"
export * from "./LabelDetails.vue?vue&type=script&lang=js"
import style0 from "./LabelDetails.vue?vue&type=style&index=0&id=2a11a1bf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a11a1bf",
  null
  
)

export default component.exports